var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHexagonGreenBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    height: 1332,
    viewBox: "0 0 1536 1332",
    width: 1536,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1159.47 1315.04-8.45 14.64h-16.61-366.41-366.414-16.609l-8.452-14.64-183.153-317.23-.755-1.308-.051.03-182.4529-316.012-8.38208-14.52 8.38208-14.52 182.4519-316.01.051.03.756-1.31 183.153-317.233 8.452-14.63803h16.609 366.414 366.41 16.61l8.45 14.63773 183.16 317.2333.76 1.322.05-.03 182.45 315.998 8.38 14.52-8.38 14.52-182.45 316-.05-.03-.76 1.32z",
    stroke: "#22e52e",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagonGreenBorder);
export default __webpack_public_path__ + "static/media/hexagon-green-border.273482369cd18133c8894f27d341d972.svg";
export { ForwardRef as ReactComponent };